//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { CalculationSetting } from "./calculation-setting";

export class Value extends CalculationSetting {
    id?: string;
    operationId?: string;
    extraDataKey?: string;
}
